import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import {
  Row,
  Button,
  Modal,
  Form,
  Input,
  Skeleton,
  Select,
  Steps,
  Tabs,
  Collapse,
  Tooltip,
} from 'antd';

import _ from 'lodash';

import {
  AddIcon,
  UpIcon,
  DownIcon,
  EditIcon,
  DeleteIcon,
  LockIcon,
  WarningIcon,
  InfoIcon,
} from 'modules/AllBillers/components/Icons';
import permissionService from 'shared/services/PermissionService';
import H5Page from '../Preview/PreviewH5.component';
import AssignComponent from '../AssignComponent/AssignComponent.form';
import './ComponentCard.form.style.less';

import text from '../FormDetail.page.translation';

const { Step } = Steps;
const { TabPane } = Tabs;
const { Panel } = Collapse;

const FormDetailH5 = reduxForm({
  form: 'allBiller',
})(H5Page);

const { Option } = Select;

const AssignComponentForm = Form.create()(AssignComponent);

const { checkPermission } = permissionService;
export default class CardComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedForm: 'general',

      activeComponentLength: 0,
      activeComponents: [],
      duplicateActiveComponents: [],

      paymentComponentLength: 0,
      paymentComponents: [],
      duplicatePaymentComponents: [],

      selectedComponentIndex: null,
      formModal: false,
      deleteComponentModal: false,

      devices: [
        {
          label: 'Default-Skywalker',
          dimension: { width: 400, height: 700 },
        },
        {
          label: 'iPhone 5/SE',
          dimension: { width: 320, height: 568 },
        },
        {
          label: 'iPhone 6/7/8',
          dimension: { width: 375, height: 667 },
        },
        {
          label: 'iPhone 6/7/8 Plus',
          dimension: { width: 414, height: 736 },
        },
        {
          label: 'iPhone X',
          dimension: { width: 375, height: 812 },
        },
        {
          label: 'Samsung Galaxy S10/Note10',
          dimension: { width: 412, height: 869 },
        },
      ],

      step: 0,
      sectionHeader: 'banner',
      validationPrefix: 'dynamic',
      showPrefix: 'no',
      selectedChanel: 'switching',

      error: {
        a: {
          config: false,
          component: false,
        },
        b: {
          config: false,
          component: false,
        },
      },

      activePanel: ['1'],
    };
  }

  _updateState = value => {
    this.setState(value);
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.currentValue !== this.props.currentValue) {
      this._updateState({
        activeComponents: this.props.currentValue.components,
        duplicateActiveComponents: this.props.currentValue.components,
        paymentComponents: this.props.currentValue.paymentComponents,
        duplicatePaymentComponents: this.props.currentValue.paymentComponents,
        sectionHeader: this.props.currentValue.sectionHeader,
        validationPrefix: this.props.currentValue.validationPrefix,
        showPrefix: this.props.currentValue.showPrefix,
        selectedChanel: this.props.currentValue.selectedChanel,
      });
    }

    if (
      prevState.selectedChanel !== this.state.selectedChanel &&
      this.state.selectedChanel === 'switching'
    ) {
      const currentActivePanel = [...this.state.activePanel];
      const activePanel = [];

      currentActivePanel.forEach(item => {
        if (item !== '3' && item !== '4') {
          activePanel.push(item);
        }
      });

      this._updateState({
        activePanel,
      });
    }

    const checkActiveComponentInput = this.state.activeComponents.findIndex(
      item =>
        item.component === 'AmountInput' ||
        item.component === 'AmountInputPredefined',
    );
    const checkPaymentComponentInputLength = this.state.paymentComponents
      .length;

    if (
      this.props.isUpdate &&
      _.get(this.state, 'error.a.component') === false &&
      ((this.state.selectedChanel === 'genesis' &&
        checkActiveComponentInput !== -1) ||
        this.state.activeComponents.length < 1)
    ) {
      this._updateState(previousState => ({
        error: {
          ...previousState.error,
          a: {
            ...previousState.error.a,
            component: true,
          },
        },
      }));
    }

    if (
      this.props.isUpdate &&
      _.get(this.state, 'error.b.component') === false &&
      this.state.selectedChanel === 'genesis' &&
      checkPaymentComponentInputLength < 1
    ) {
      this._updateState(previousState => ({
        error: {
          ...previousState.error,
          b: {
            ...previousState.error.b,
            component: true,
          },
        },
      }));
    }

    if (
      (this.state.selectedChanel !== prevState.selectedChanel &&
        this.state.selectedChanel === 'switching') ||
      (_.get(prevState, 'error.a.component') === true &&
        ((this.state.selectedChanel === 'genesis' &&
          checkActiveComponentInput === -1) ||
          this.state.activeComponents.length > 0))
    ) {
      this._updateState(previousState => ({
        error: {
          ...previousState.error,
          a: {
            ...previousState.error.a,
            component: false,
          },
        },
      }));
    }

    if (
      (this.state.selectedChanel !== prevState.selectedChanel &&
        this.state.selectedChanel === 'switching') ||
      (_.get(prevState, 'error.b.component') === true &&
        checkPaymentComponentInputLength > 0)
    ) {
      this._updateState(previousState => ({
        error: {
          ...previousState.error,
          b: {
            ...previousState.error.b,
            component: false,
          },
        },
      }));
    }
  }

  _onMoveDown = (index, isGeneral) => () => {
    const currentComponents = isGeneral
      ? [...this.state.activeComponents]
      : [...this.state.paymentComponents];

    const temp = currentComponents[index + 1];
    currentComponents[index + 1] = currentComponents[index];
    currentComponents[index] = temp;

    if (isGeneral) {
      this.setState(prevState => ({
        activeComponents: currentComponents,
        duplicateActiveComponents: currentComponents,
        activeComponentLength: prevState.activeComponentLength + 1,
      }));
    } else {
      this.setState(prevState => ({
        paymentComponents: currentComponents,
        duplicatePaymentComponents: currentComponents,
        paymentComponentLength: prevState.paymentComponentLength + 1,
      }));
    }
  };

  _onMoveUp = (index, isGeneral) => () => {
    const currentComponents = isGeneral
      ? [...this.state.activeComponents]
      : [...this.state.paymentComponents];

    const temp = currentComponents[index - 1];
    currentComponents[index - 1] = currentComponents[index];
    currentComponents[index] = temp;

    if (isGeneral) {
      this.setState(prevState => ({
        activeComponents: currentComponents,
        duplicateActiveComponents: currentComponents,
        activeComponentLength: prevState.activeComponentLength + 1,
      }));
    } else {
      this.setState(prevState => ({
        paymentComponents: currentComponents,
        duplicatePaymentComponents: currentComponents,
        paymentComponentLength: prevState.paymentComponentLength + 1,
      }));
    }
  };

  _setSelectedComponent = (index, isEdit, isGeneral) => () => {
    this.setState({
      selectedComponentIndex: index,
      formModal: isEdit,
      deleteComponentModal: !isEdit,
      selectedForm: isGeneral ? 'general' : 'payment',
    });
  };

  _cancelDelete = () => {
    this.setState({ deleteComponentModal: false });
  };

  _confirmDelete = isGeneral => () => {
    const {
      activeComponents,
      paymentComponents,
      selectedComponentIndex,
    } = this.state;
    const currentComponents = isGeneral
      ? [...activeComponents]
      : [...paymentComponents];

    currentComponents.splice(selectedComponentIndex, 1);

    if (isGeneral) {
      this.setState(prevState => ({
        activeComponents: currentComponents,
        activeComponentLength: prevState.activeComponentLength - 1,
        deleteComponentModal: false,
      }));
    } else {
      this.setState(prevState => ({
        paymentComponents: currentComponents,
        paymentComponentLength: prevState.paymentComponentLength - 1,
        deleteComponentModal: false,
      }));
    }
  };

  _renderModalDelete = () => {
    const {
      selectedComponentIndex,
      activeComponents,
      paymentComponents,
      deleteComponentModal,
      selectedForm,
    } = this.state;

    const isVisible = deleteComponentModal;

    return (
      <Modal
        title="Confirmation"
        visible={isVisible}
        footer={null}
        closable={false}
        className="modal-delete"
      >
        {isVisible && (
          <>
            <center>
              Are you sure want to remove this{' '}
              <strong>
                {deleteComponentModal &&
                  _.get(
                    selectedForm === 'general'
                      ? activeComponents
                      : paymentComponents,
                    `${selectedComponentIndex}.name`,
                  )}{' '}
                ?
              </strong>
            </center>

            <center className="btn-group-delete">
              <Button className="btn-cancel" onClick={this._cancelDelete}>
                Cancel
              </Button>

              <Button
                className="btn-delete"
                type="danger"
                onClick={this._confirmDelete(selectedForm === 'general')}
              >
                Delete
              </Button>
            </center>
          </>
        )}
      </Modal>
    );
  };

  _renderActiveComponent = isGeneral => (component, index, length) => {
    const showWarning =
      this.state.selectedChanel === 'genesis' &&
      isGeneral &&
      this.props.isUpdate &&
      (component.component === 'AmountInput' ||
        component.component === 'AmountInputPredefined');

    return (
      <>
        <div
          className={`active-component ${showWarning ? 'disabled' : ''}`}
          key={`${component.name}_index`}
        >
          <div className="active-component-name">
            <span>{`${component.name} / ${component.component}`}</span>
          </div>
          {this.props.isUpdate && (
            <div className="icon-wrapper">
              <DownIcon
                active={length && index !== length - 1}
                onClick={this._onMoveDown(index, isGeneral)}
              />
              <UpIcon
                active={length && index !== 0}
                onClick={this._onMoveUp(index, isGeneral)}
              />
              <EditIcon
                onClick={this._setSelectedComponent(index, true, isGeneral)}
              />
              <DeleteIcon
                onClick={this._setSelectedComponent(index, false, isGeneral)}
              />
            </div>
          )}
        </div>
        {showWarning && (
          <div className="warning-component">
            This component should be located under “B. Payment Input Page
            Component Set Up” if supported channel set as “Direct Bill Payment
            (Genesis)”
          </div>
        )}
      </>
    );
  };

  _renderActiveComponents = isGeneral => {
    let activeComponents = [...this.state.activeComponents];
    if (!isGeneral) {
      activeComponents = [...this.state.paymentComponents];
    }

    if (activeComponents.length === 1) {
      return this._renderActiveComponent(isGeneral)(
        activeComponents[0],
        0,
        false,
      );
    }
    return activeComponents.map((component, index) =>
      this._renderActiveComponent(isGeneral)(
        component,
        index,
        activeComponents.length,
      ),
    );
  };

  _toggleAssign = (isOpen, isGeneral) => () => {
    this.setState({
      formModal: isOpen,
      selectedComponentIndex: null,
      selectedForm: isGeneral ? 'general' : 'payment',
    });
  };

  _onSubmitAssignedComponent = value => {
    this.setState(prevState => {
      const updateIndex = this.state.selectedComponentIndex;
      const isGeneral = prevState.selectedForm === 'general';

      const newArray = isGeneral
        ? prevState.activeComponents
        : prevState.paymentComponents;

      if (updateIndex !== null && updateIndex > -1) {
        newArray[updateIndex] = value;
      } else {
        newArray.push(value);
      }

      if (isGeneral) {
        return {
          activeComponents: newArray,
          duplicateActiveComponents: newArray,
          formModal: false,
          activeComponentLength: prevState.activeComponentLength + 1,
          selectedComponentIndex: -1,
        };
      }
      return {
        paymentComponents: newArray,
        duplicatePaymentComponents: newArray,
        formModal: false,
        paymentComponentLength: prevState.paymentComponentLength + 1,
        selectedComponentIndex: -1,
      };
    });
  };

  _renderAssignComponent = () => {
    const {
      selectedForm,
      duplicateActiveComponents,
      duplicatePaymentComponents,
      selectedComponentIndex,
      formModal,
    } = this.state;
    const isGeneral = selectedForm === 'general';

    return (
      <Modal
        title={this.renderModalTitle('Assign Component')}
        visible={formModal}
        footer={null}
        destroyOnClose
        onCancel={this._toggleAssign(false, isGeneral)}
        className="modal-create"
      >
        {formModal && (
          <AssignComponentForm
            formValue={
              isGeneral
                ? duplicateActiveComponents[selectedComponentIndex]
                : duplicatePaymentComponents[selectedComponentIndex]
            }
            isPayment={!isGeneral}
            intl={this.props.intl}
            cancelFunction={this._toggleAssign(false, isGeneral)}
            onSubmit={this._onSubmitAssignedComponent}
          />
        )}
      </Modal>
    );
  };

  renderModalTitle = title => (
    <Row className="modal-title-form-builder">{title}</Row>
  );

  _onSubmitForm = (err, formValues) => {
    const {
      activeComponents,
      paymentComponents,
      sectionHeader,
      selectedChanel,
      validationPrefix,
      showPrefix,
    } = this.state;

    const { currentValue } = this.props;

    const currentForm = {
      ...formValues,
      en: {
        ...currentValue.en,
        ...formValues.en,
      },
      id: {
        ...currentValue.id,
        ...formValues.id,
      },
    };

    if (!err) {
      this.setState({ step: 0 }, () => {
        this.props.onSave({
          ...currentForm,
          selectedChanel,
          components: activeComponents,
          paymentComponents,
          selectedComponentIndex: null,
          sectionHeader,
          validationPrefix,
          showPrefix,
        });
      });
    }
  };

  _onValidate = (
    isGeneral,
    onSuccess,
    { validatePanelA, enValidatePanelB, validatePanelB },
  ) => (err, formValues) => {
    const error = {
      a: {
        config: false,
        component: false,
      },
      b: {
        config: false,
        component: false,
      },
    };
    const { error: currentError } = this.state;
    const componentValidationA =
      this.state.activeComponents.length !== 0 && !currentError.a.component;
    const componentValidationB =
      this.state.paymentComponents.length !== 0 && !currentError.b.component;

    let isNotError = !err && componentValidationA;

    if (!isGeneral) {
      isNotError = !err && componentValidationA && componentValidationB;
    }

    if (isNotError) {
      this.setState(
        {
          error,
        },
        () => {
          onSuccess(err, formValues);
        },
      );
    } else {
      validatePanelA.forEach(key => {
        if (_.get(err, `${key}.errors.length`, '0') > 0) {
          error.a.config = true;
        }
      });
      error.a.component =
        this.state.activeComponents.length === 0 || currentError.a.component;
      let stepBack = false;
      if (!isGeneral) {
        validatePanelB.forEach(key => {
          if (_.get(err, `${key}.errors.length`, '0') > 0) {
            error.b.config = true;
          }
        });
        enValidatePanelB.forEach(key => {
          if (_.get(err, `${key}.errors.length`, '0') > 0) {
            stepBack = true;
          }
        });
        error.b.component =
          this.state.paymentComponents.length === 0 || currentError.b.component;
      }

      this.setState({ error, ...(stepBack && { step: 0 }) });
    }
  };

  _validateFields = (lang, onSuccess) => {
    const {
      form: { validateFields },
    } = this.props;

    const isGeneral = this.state.selectedChanel === 'switching';

    const validatePanelA = [`${lang}.title`, `${lang}.btnText`];
    const validatePanelB = [`${lang}.paymentTitle`, `${lang}.paymentBtnText`];
    const enValidatePanelA = [`en.title`, `en.btnText`];
    const enValidatePanelB = [`en.paymentTitle`, `en.paymentBtnText`];

    let fieldsToValidateEn = [...validatePanelA];
    let fieldsToValidateId = [...validatePanelA, ...enValidatePanelA];

    if (!isGeneral) {
      fieldsToValidateEn = fieldsToValidateEn.concat(validatePanelB);
      fieldsToValidateId = fieldsToValidateId.concat([
        ...validatePanelB,
        ...enValidatePanelB,
      ]);
    }

    if (lang === 'id') {
      validateFields(
        fieldsToValidateId,
        this._onValidate(isGeneral, onSuccess, {
          validatePanelA,
          validatePanelB,
          enValidatePanelB,
        }),
      );
    } else {
      validateFields(
        fieldsToValidateEn,
        this._onValidate(isGeneral, onSuccess, {
          validatePanelA,
          validatePanelB,
          enValidatePanelB,
        }),
      );
    }
  };

  _handleSubmit = e => {
    e.preventDefault();
    this._validateFields('id', this._onSubmitForm);
  };

  _handleCancel = e => {
    e.preventDefault();
    const {
      form: { resetFields },
      onReset,
      defaultComponent,
      currentValue,
    } = this.props;
    resetFields();
    onReset();

    this.setState(prevState => {
      const activePanel = [...prevState.activePanel];

      activePanel.forEach((item, index) => {
        if (item === '3' || item === '4') {
          activePanel.splice(index, 1);
        }
      });
      return {
        activeComponents: _.get(defaultComponent, 'components', []),
        duplicateActiveComponents: _.get(defaultComponent, 'components', []),
        selectedChanel: _.get(defaultComponent, 'selectedChanel', 'switching'),
        paymentComponents: _.get(defaultComponent, 'paymentComponents', []),
        duplicatePaymentComponents: _.get(
          defaultComponent,
          'paymentComponents',
          [],
        ),
        error: {
          a: {
            config: false,
            component: false,
          },
          b: {
            config: false,
            component: false,
          },
        },
        sectionHeader: currentValue.sectionHeader,
        validationPrefix: currentValue.validationPrefix,
        showPrefix: currentValue.showPrefix,
        activePanel,
      };
    });
  };

  _changeSteper = step => () => {
    if (step === 1) {
      this._validateFields('en', () => {
        this.setState({ step });
      });
    } else {
      this.setState({
        step,
        error: {
          a: {
            config: false,
            component: false,
          },
          b: {
            config: false,
            component: false,
          },
        },
      });
    }
  };

  _onEdit = () => {
    this.props.onEdit();
    this.setState({
      step: 0,
    });
  };

  _renderComponentsSubmit = lang => {
    const {
      intl: { formatMessage },
      isUpdate,
    } = this.props;

    const btnBlue =
      lang === 'en' ? (
        <Button type="primary" onClick={this._changeSteper(1)}>
          Next
        </Button>
      ) : (
        <Button type="primary" onClick={this._handleSubmit}>
          {formatMessage(text.btn.save)}
        </Button>
      );

    const btnGray =
      lang === 'en' ? (
        <Button type="default" className="ml-15" onClick={this._handleCancel}>
          {formatMessage(text.btn.cancel)}
        </Button>
      ) : (
        <Button
          type="default"
          className="ml-15"
          onClick={this._changeSteper(0)}
        >
          Back
        </Button>
      );
    return (
      <div className="component-submit">
        {isUpdate ? (
          <>
            {btnBlue}
            {btnGray}
          </>
        ) : (
          <Button type="primary" onClick={this._onEdit}>
            {formatMessage(text.btn.edit)}
          </Button>
        )}
      </div>
    );
  };

  _renderComponentList = isGeneral => {
    const {
      intl: { formatMessage },
      isUpdate,
    } = this.props;

    let activeComponents = [...(this.state.activeComponents || [])];
    if (!isGeneral) {
      activeComponents = [...(this.state.paymentComponents || [])];
    }

    const isHaveComponent = activeComponents.length > 0;
    const showPaymentWarning =
      this.state.selectedChanel === 'genesis' && !isGeneral && !isHaveComponent;

    let addIconColor = !isUpdate ? '#e4e4e4' : '';
    if (showPaymentWarning) {
      addIconColor = '#ff5d55';
    }

    return (
      <div className="components">
        {activeComponents.length > 0 && this._renderActiveComponents(isGeneral)}

        {activeComponents.length < (isGeneral ? 4 : 2) && (
          <div
            className={`component-btn ${!isUpdate ? 'disable' : ''} ${
              showPaymentWarning ? 'warning' : ''
            }`}
            onClick={this._toggleAssign(isUpdate, isGeneral)}
          >
            <AddIcon color={addIconColor} />
            <span>{formatMessage(text.btn.add)}</span>
          </div>
        )}
        {showPaymentWarning && (
          <div className="warning-component">
            This component is required, please configure the component
          </div>
        )}
      </div>
    );
  };

  _renderLeftContent = step => {
    const {
      form: { getFieldDecorator },
      isUpdate,
      currentValue,
    } = this.props;

    const lang = step === 0 ? 'en' : 'id';

    const supportedChannel = [
      { value: 'switching', label: 'Switching & Direct Cashout' },
      { value: 'genesis', label: 'Direct Bill Payment (Genesis)' },
    ];

    const selectBanner = [
      { value: 'banner', label: 'Banner' },
      { value: 'repeat', label: 'Recent Transaction' },
      { value: 'both', label: 'Banner & Recent Transaction' },
      { value: 'none', label: 'None' },
    ];

    const validationOption = [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
      { value: 'dynamic', label: 'Dynamic' },
    ];

    const showValidation = [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ];

    const isGeneral = this.state.selectedChanel === 'switching';

    const {
      error: {
        a: { config: errorConfigA, component: errorComponentA },
        b: { config: errorConfigB, component: errorComponentB },
      },
    } = this.state;

    return (
      <div className="form-components-left">
        <Collapse
          defaultActiveKey={['1']}
          onChange={activePanel => {
            this.setState({ activePanel });
          }}
          activeKey={this.state.activePanel}
        >
          <Panel
            className={errorConfigA ? 'panel-error' : ''}
            extra={errorConfigA && <WarningIcon />}
            header="A. Form Page Configuration"
            key="1"
          >
            <Form.Item label="Supported Channel">
              <Select
                placeholder="Supported Channel"
                size="large"
                disabled={!isUpdate}
                value={this.state.selectedChanel}
                onChange={selectedChanel => {
                  this.setState({ selectedChanel });
                }}
              >
                {supportedChannel.map(item => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item required label="Biller Title">
              {getFieldDecorator(`${lang}.title`, {
                initialValue: _.get(currentValue, `${lang}.title`),
                rules: [
                  {
                    required: true,
                    message: 'Please input biller title',
                  },
                  {
                    max: 36,
                    message: `Max length is 36`,
                  },
                ],
              })(
                <Input
                  type="text"
                  size="large"
                  disabled={!isUpdate}
                  placeholder="Enter biller title"
                />,
              )}
            </Form.Item>

            <Form.Item required label="Biller Header">
              <Select
                placeholder="Choose Header"
                size="large"
                disabled={!isUpdate}
                value={this.state.sectionHeader}
                onChange={sectionHeader => {
                  this.setState({ sectionHeader });
                }}
              >
                {selectBanner.map(item => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={
                <>
                  <span>Validation of VA Prefix</span>
                  <span className="requiered-colon" />
                  <Tooltip
                    placement="topLeft"
                    title="If set active, user must insert their full virtual account number with prefix."
                  >
                    <span className="tooltip-icon">
                      <InfoIcon />
                    </span>
                  </Tooltip>
                </>
              }
            >
              <Select
                placeholder="Choose validation"
                size="large"
                disabled={!isUpdate}
                value={this.state.validationPrefix}
                onChange={validationPrefix => {
                  this.setState({ validationPrefix });
                }}
              >
                {validationOption.map(item => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={
                <>
                  <span>Show VA Prefix</span>
                  <span className="requiered-colon" />
                  <Tooltip
                    placement="topLeft"
                    title="If set as Yes, VA Prefix will be shown in confirmation slider, repeat order component, and transaction details & history"
                  >
                    <span className="tooltip-icon">
                      <InfoIcon />
                    </span>
                  </Tooltip>
                </>
              }
            >
              <Select
                placeholder="Choose answer"
                size="large"
                disabled={!isUpdate}
                value={this.state.showPrefix}
                onChange={showPrefix => {
                  this.setState({ showPrefix });
                }}
              >
                {showValidation.map(item => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item required label="CTA Button Title">
              {getFieldDecorator(`${lang}.btnText`, {
                initialValue: _.get(currentValue, `${lang}.btnText`),
                rules: [
                  {
                    required: true,
                    message: 'Please input button title',
                  },
                  {
                    max: 30,
                    message: `Max length is 30`,
                  },
                ],
              })(
                <Input
                  type="text"
                  size="large"
                  disabled={!isUpdate}
                  placeholder="Enter button title"
                />,
              )}
            </Form.Item>
          </Panel>
          <Panel
            className={errorComponentA ? 'panel-error' : ''}
            extra={errorComponentA && <WarningIcon />}
            header="A. Form Page Component Set Up"
            key="2"
          >
            {this._renderComponentList(true)}
          </Panel>
          <Panel
            className={errorConfigB && !isGeneral ? 'panel-error' : ''}
            disabled={isGeneral}
            clo
            header="B. Payment Input Page Configuration"
            key="3"
            extra={errorConfigB ? <WarningIcon /> : isGeneral && <LockIcon />}
          >
            <>
              <Form.Item required label="Page Title">
                {getFieldDecorator(`${lang}.paymentTitle`, {
                  initialValue: _.get(currentValue, `${lang}.paymentTitle`),
                  rules: [
                    {
                      required: true,
                      message: 'Please input page title',
                    },
                    {
                      max: 36,
                      message: `Max length is 36`,
                    },
                  ],
                })(
                  <Input
                    type="text"
                    size="large"
                    disabled={!isUpdate}
                    placeholder="Enter your page title"
                  />,
                )}
              </Form.Item>

              <Form.Item required label="CTA Button Title">
                {getFieldDecorator(`${lang}.paymentBtnText`, {
                  initialValue: _.get(currentValue, `${lang}.paymentBtnText`),
                  rules: [
                    {
                      required: true,
                      message: 'Please input button title',
                    },
                    {
                      max: 30,
                      message: `Max length is 30`,
                    },
                  ],
                })(
                  <Input
                    type="text"
                    size="large"
                    disabled={!isUpdate}
                    placeholder="Enter button title"
                  />,
                )}
              </Form.Item>
            </>
          </Panel>
          <Panel
            className={errorComponentB && !isGeneral ? 'panel-error' : ''}
            disabled={isGeneral}
            header="B. Payment Input Page Component Set Up"
            key="4"
            extra={
              errorComponentB ? <WarningIcon /> : isGeneral && <LockIcon />
            }
          >
            {this._renderComponentList(false)}
          </Panel>
        </Collapse>
      </div>
    );
  };

  _renderRightContent = step => {
    const {
      form: { getFieldDecorator, getFieldValue },
      formName,
    } = this.props;
    const { devices } = this.state;

    const selectedDevice = getFieldValue('prevDevice') || 0;
    const lang = step === 0 ? 'en' : 'id';

    const isGeneral = this.state.selectedChanel === 'switching';

    return (
      <div className="form-components-right">
        <Skeleton
          loading={this.props.loading}
          active
          paragraph={{ rows: 3, width: ['100%', '100%'] }}
          title={false}
        >
          <div className="select-device">
            <Form.Item label="Preview Screen">
              {getFieldDecorator('prevDevice', {
                initialValue: 0,
              })(
                <Select size="large">
                  {devices.map((device, index) => (
                    <Option key={device.label} value={index}>
                      {device.label}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </div>

          <div className="preview-device">
            <FormDetailH5
              title={formName || 'Form Name'}
              dimension={devices[selectedDevice].dimension}
              loading={this.props.loading}
              billerTitle={getFieldValue(`${lang}.title`)}
              btnText={getFieldValue(`${lang}.btnText`) || 'NEXT'}
              sectionHeader={this.state.sectionHeader}
              arrayLength={this.state.activeComponentLength}
              activeComponents={this.state.activeComponents}
              intl={this.props.intl}
              lang={lang}
            />

            <FormDetailH5
              title={getFieldValue(`${lang}.paymentTitle`) || 'Page Title'}
              isPayment
              enablePayment={!isGeneral}
              dimension={devices[selectedDevice].dimension}
              loading={this.props.loading}
              btnText={getFieldValue(`${lang}.paymentBtnText`) || 'BUTTON'}
              arrayLength={this.state.paymentComponentLength}
              activeComponents={this.state.paymentComponents}
              intl={this.props.intl}
              lang={lang}
            />
          </div>
        </Skeleton>
      </div>
    );
  };

  _renderContents = step => {
    const {
      intl: { formatMessage },
    } = this.props;
    const lang = step === 0 ? 'en' : 'id';

    return (
      <div className="form-components">
        <div className="connected-form">
          <span className="title">{formatMessage(text.detail.formConfig)}</span>
        </div>
        <div className="form-body">
          {this._renderLeftContent(step)}
          {this._renderRightContent(step)}
        </div>
        <div className="form-footer">
          {(checkPermission('Form Builder:update', true) ||
            checkPermission('Form Builder:create', true)) &&
            this._renderComponentsSubmit(lang)}
        </div>
      </div>
    );
  };

  _changeStep = step => {
    this.setState({ step });
  };

  _changeTab = tab => {
    this.setState({ step: tab - 1 });
  };

  render() {
    const { step: key } = this.state;

    return (
      <Form>
        {this.props.isUpdate ? (
          <div>
            <div className="step-language">
              <Steps current={this.state.step}>
                <Step
                  title="English"
                  description="Configure your form language in English."
                />
                <Step
                  title="Indonesian"
                  description="Configure your form language in Bahasa."
                />
              </Steps>
            </div>
            <div style={{ display: key === 0 ? 'block' : 'none' }}>
              {this._renderContents(0)}
            </div>
            <div style={{ display: key === 1 ? 'block' : 'none' }}>
              {this._renderContents(1)}
            </div>
          </div>
        ) : (
          <Tabs
            type="card"
            style={{ paddingTop: '20px' }}
            onChange={this._changeTab}
          >
            <TabPane tab="English" key="1">
              {this._renderContents(0)}
            </TabPane>
            <TabPane tab="Indonesian" key="2">
              {this._renderContents(1)}
            </TabPane>
          </Tabs>
        )}
        {this._renderAssignComponent()}
        {this._renderModalDelete()}
      </Form>
    );
  }
}

CardComponent.propTypes = {
  intl: PropTypes.object.isRequired,
  form: PropTypes.object,
  isUpdate: PropTypes.bool,
  onEdit: PropTypes.func,
  onSave: PropTypes.func,
  onReset: PropTypes.func,
  currentValue: PropTypes.object,
  defaultComponent: PropTypes.object,
  formName: PropTypes.string,
  loading: PropTypes.bool,
};
